import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import Nav from './Nav';
import Footer from './Footer';
import BackToTop from './BackToTop';

export const Layout = () => {
  const location = useLocation();
  // All pages use the solid light nav (as on the sample header)
  const transparentNav = false;

  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [location.pathname]);

  return (
    <div className="App min-h-screen flex flex-col">
      <Nav transparent={transparentNav} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
      <Toaster
        position="top-right"
        richColors
        theme="dark"
        toastOptions={{
          style: { fontFamily: '"EB Garamond", Georgia, serif', borderRadius: 0, background: '#0B0B0C', color: '#FDFBF7', border: '1px solid rgba(184,151,74,0.4)' },
        }}
      />
    </div>
  );
};

export default Layout;
